export const ROLES = {
  ADMIN: "8jNNqsUTkt5VdviVUDM6",
  MD: "1Z4qUDASru6T4n4uE63z",
  BOD: "49N7oTFM3z3QpQGNzRKK",
  MARKETING_EXECUTIVE: "XB4U81zass5rB2GMnet5",
  TELECALLER: "cIBvUTkTJsDkfMCzSRgN",
  FIELD_WORKER: "rigFhL6QJlWSc7tAdsIi",
  LEAD_UPLOADER: "vql9AMXe8LJN8SFerrzJ",
  CMO: "VGgnVkHOfVibZGFCXc3L",
  PROCUREMENT_HEAD: "yD0pOCFmsTnA6wNK1Rog",
  BACKEND: "caz3mdD6XEM5Jzaqwq3Q",
  FRONTEND: "5dIONRjQ08lbrDRJV8f8",
  ROUGH_DRAFTER: "rGrVihCUeCbeIajYEruL",
  Procurer: "TiSq7g9gUEt8q6bvl1Je",
  HR: "OkBtMPvZXLdxOvm4Ap5l",
};

export const RoleOptions = [
  {
    label: "Admin",
    value: "8jNNqsUTkt5VdviVUDM6",
  },
  {
    label: "MD",
    value: "1Z4qUDASru6T4n4uE63z",
  },
  {
    label: "BOD",
    value: "49N7oTFM3z3QpQGNzRKK",
  },
  {
    label: "Marketing Executive",
    value: "XB4U81zass5rB2GMnet5",
  },
  {
    label: "Telecaller",
    value: "cIBvUTkTJsDkfMCzSRgN",
  },
  {
    label: "Field Worker",
    value: "rigFhL6QJlWSc7tAdsIi",
  },
  {
    label: "Lead Uploader",
    value: "vql9AMXe8LJN8SFerrzJ",
  },
  {
    label: "CMO",
    value: "VGgnVkHOfVibZGFCXc3L",
  },
  {
    label: "Procurement Head",
    value: "yD0pOCFmsTnA6wNK1Rog",
  },
  {
    label: "Backend",
    value: "caz3mdD6XEM5Jzaqwq3Q",
  },
  {
    label: "Frontend",
    value: "5dIONRjQ08lbrDRJV8f8",
  },
  {
    label: "Rough Drafter",
    value: "rGrVihCUeCbeIajYEruL",
  },
  {
    label: "Procurer",
    value: "TiSq7g9gUEt8q6bvl1Je",
  },
  {
    label: "HR",
    value: "OkBtMPvZXLdxOvm4Ap5l",
  },
];


// Crm Department Roles

export const saleDepartmentRoles = [
 
  {
    label: "BOD",
    value: "49N7oTFM3z3QpQGNzRKK",
  },
  {
    label: "Marketing Executive",
    value: "XB4U81zass5rB2GMnet5",
  },
  {
    label: "Telecaller",
    value: "cIBvUTkTJsDkfMCzSRgN",
  },
  {
    label: "Field Worker",
    value: "rigFhL6QJlWSc7tAdsIi",
  },
  {
    label: "Lead Uploader",
    value: "vql9AMXe8LJN8SFerrzJ",
  },
 
]

export const managementDepartmentRoles = [
{
  label: "Admin",
  value: "8jNNqsUTkt5VdviVUDM6",
},
{
  label: "CMO",
  value: "VGgnVkHOfVibZGFCXc3L",
},
{
  label: "MD",
  value: "1Z4qUDASru6T4n4uE63z",
},
{
  label: "HR",
  value: "OkBtMPvZXLdxOvm4Ap5l",
}
]

export const revenueDepartmentRoles = [
 {
  label: "Procurement Head",
  value: "yD0pOCFmsTnA6wNK1Rog",
 },
 {
  label: "Backend",
  value: "caz3mdD6XEM5Jzaqwq3Q",
 },
 {
  label: "Frontend",
  value: "5dIONRjQ08lbrDRJV8f8",
 },
 {
  label: "Rough Drafter",
  value: "rGrVihCUeCbeIajYEruL",
 },
 {
  label: "Procurer",
  value: "TiSq7g9gUEt8q6bvl1Je",
 }
]


export const roleIdProcurement = [
  "1Z4qUDASru6T4n4uE63z" ,  // MD
  "TiSq7g9gUEt8q6bvl1Je",  // Procurer
]

export const backendProcurementHeadRoles = [
  "caz3mdD6XEM5Jzaqwq3Q",  // Backend
"yD0pOCFmsTnA6wNK1Rog",  // Procurement Head
]

export const queryUserList = [
  "yD0pOCFmsTnA6wNK1Rog",  // Procurement Head
  "caz3mdD6XEM5Jzaqwq3Q",  // Backend
  "TiSq7g9gUEt8q6bvl1Je",  // Procurer
  "1Z4qUDASru6T4n4uE63z",  // MD
  "5dIONRjQ08lbrDRJV8f8",  // Frontend  
]

export const backendUserList = [
  "yD0pOCFmsTnA6wNK1Rog",  // Procurement Head
]

